<form [formGroup]="formlyForm" class="control-attributes active-control">
  <formly-form appearance="outline" style="width: 100%;" [model]="model" [fields]="fields" [options]="options" [form]="formlyForm"></formly-form>
</form>
